'use client';

import { useCallback, useEffect, useRef, useState, type ReactNode } from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import { ConfirmContext, type ConfirmOptions } from './confirm-context';

export function ConfirmProvider({ children }: { children: ReactNode }) {
  const [options, setOptions] = useState<ConfirmOptions | null>(null);
  const resolve = useRef<((answer: boolean) => void) | null>(null);
  const confirm = useCallback((request: string | ConfirmOptions) => {
    resolve.current?.(false);
    setOptions(typeof request === 'string' ? { description: request, tone: 'warning' } : request);
    return new Promise<boolean>((done) => { resolve.current = done; });
  }, []);
  const close = useCallback((answer: boolean) => { resolve.current?.(answer); resolve.current = null; setOptions(null); }, []);
  useEffect(() => () => { resolve.current?.(false); }, []);
  const ar = typeof document === 'undefined' || document.documentElement.lang.startsWith('ar');
  return <ConfirmContext.Provider value={confirm}>{children}
    <Dialog open={Boolean(options)} onClose={() => close(false)} aria-labelledby="zaytun-confirm-title" aria-describedby="zaytun-confirm-description" dir={ar ? 'rtl' : 'ltr'}>
      <DialogTitle id="zaytun-confirm-title">{options?.title ?? (ar ? 'تأكيد العملية' : 'Confirm action')}</DialogTitle>
      <DialogContent><DialogContentText id="zaytun-confirm-description">{options?.description}</DialogContentText></DialogContent>
      <DialogActions><Button autoFocus variant="outlined" onClick={() => close(false)}>{options?.cancelLabel ?? (ar ? 'تراجع' : 'Cancel')}</Button><Button variant="contained" color={options?.tone === 'danger' ? 'error' : 'primary'} onClick={() => close(true)}>{options?.confirmLabel ?? (ar ? 'تأكيد' : 'Confirm')}</Button></DialogActions>
    </Dialog>
  </ConfirmContext.Provider>;
}
